module.exports = require("axios");


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 123
// module chunks = 0